export default function validatePrefixFactory(prefix) {
  return function validatePrefix(value) {
    // Cannot validate if value is not a string
    if (typeof value !== "string") {
      return true;
    }

    if (value.startsWith(prefix)) {
      return true;
    }

    return `Must begin with ${prefix}`;
  };
}
